import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9738fbe4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "form-main" }
const _hoisted_3 = { class: "form-btn-group" }

import {ScForm} from "@/models/ScForm";
import {FormContainerGroup} from "@/components/business/crud/widgets/FormWidgetContainer";
import WidgetFormBody from "@/components/business/crud/form/WidgetFormBody.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WidgetForm',
  props: {
    form: {},
    canToggle: { type: Boolean, default: true },
    toggle: {},
    status: { default: "edit" },
    groups: {}
  },
  emits: ["submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;



return (_ctx: any,_cache: any) => {
  const _component_sc_btn = _resolveComponent("sc-btn")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(WidgetFormBody, { groups: _ctx.groups }, null, 8, ["groups"])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createVNode(_component_sc_btn, {
        type: "primary",
        handler: () => emit('submit'),
        text: "提交"
      }, null, 8, ["handler"]),
      _createVNode(_component_sc_btn, {
        style: {"margin-left":"10px"},
        disabled: !_ctx.form.canReset.value,
        handler: () => _ctx.form.reset(),
        text: "重置"
      }, null, 8, ["disabled", "handler"])
    ], 512), [
      [_vShow, _ctx.status === 'edit']
    ])
  ]))
}
}

})